import signals from 'signals';

export default class Watcher {
  constructor(application, config) {
    this.application = application;
    this.config = config || {};

    this.tokenExpired = new signals.Signal();
  }

  watch(token, expires_in) {
    this.unwatch();

    this.token = token;

    if (expires_in > 0 && expires_in < 2147482) {
      if (!this.config.credentials || !this.config.credentials.no_watchers) {
        this._timeout = setTimeout(() => this._onExpired(), expires_in * 1000);
      }

      this._expiresAt = Date.now() + (expires_in * 1000);
    }
    else if (expires_in <= 0) {
      this._expiresAt = undefined;
      this._hasExpired = true;
      setTimeout(() => this._onExpired());
    }
  }

  unwatch() {
    this.token = undefined;
    this._hasExpired = false;

    if (this._timeout) {
      clearTimeout(this._timeout);
      this._timeout = undefined;
    }
  }

  get hasExpired() {
    let value = this._hasExpired || false;

    if (!value) {
      if (this.config.credentials && this.config.credentials.no_watchers) {
        if (this._expiresAt > 0 && this._expiresAt < Date.now()) {
          value = true;
          setTimeout(() => this._onExpired());
        }
      }
    }

    return value;
  }

  _onExpired() {
    this._hasExpired = true;
    this.tokenExpired.dispatch({
      token: this.token,
      application: this.application
    });
  }
};
